export const formatToCurrency = (number: number, currency: string = "DOP") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(number);
